import {
  BaseModule,
  BaseState,
  BaseMutationTree,
  BaseActionTree,
  BaseGetterTree,
} from '@/store/@types/base';

const state: BaseState = {
  modalData: null,
  isModalVisible: false,
  modalInnerComponentName: null,
  isFromSubscriptionsModal: false,
  needOpenPaymentModal: false,
};

const mutations: BaseMutationTree = {
  SET_MODAL_DATA(state, data) {
    state.modalData = data;
  },

  SET_MODAL_VISIBLE(state, isVisible) {
    state.isModalVisible = isVisible;
  },

  SET_MODAL_INNER_COMPONENT_NAME(state, componentName) {
    state.modalInnerComponentName = componentName;
  },

  SET_FROM_SUBSCRIPTIONS_MODAL(state, isFromSubscriptionsModal) {
    state.isFromSubscriptionsModal = isFromSubscriptionsModal;
  },

  SET_NEED_OPEN_PAYMENT_MODAL(state, isNeedOpen) {
    state.needOpenPaymentModal = isNeedOpen;
  },
};

const actions: BaseActionTree = {
  setModalData({ commit }, data) {
    commit('SET_MODAL_DATA', data);
  },

  openModal({ commit }, componentName) {
    commit('SET_MODAL_INNER_COMPONENT_NAME', componentName);
    commit('SET_MODAL_VISIBLE', true);
  },

  closeModal({ commit }) {
    commit('SET_MODAL_VISIBLE', false);
  },

  setIsFromSubscriptionsModal({ commit }, isFromSubscriptionsModal) {
    commit('SET_FROM_SUBSCRIPTIONS_MODAL', isFromSubscriptionsModal);
  },

  setNeedOpenPaymentModal({ commit }, isNeedOpen) {
    commit('SET_NEED_OPEN_PAYMENT_MODAL', isNeedOpen);
  },
};

const getters: BaseGetterTree = {
  modalData: (state) => state.modalData,
  isFromSubscriptionsModal: (state) => state.isFromSubscriptionsModal,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
} as BaseModule;
